import { Flex, Skeleton } from 'antd';
import Button from 'components/Button';
import Title from 'antd/es/typography/Title';
import WidgetCard, {
  WidgetTitle,
} from 'screens/collections/hotcash/components/WidgetCard';
import { renderInfoValue } from 'utils/helpers';

interface ActionWidgetProps {
  title?: React.ReactNode;
  ctaContent?: React.ReactNode;
  onCtaClick?: () => void;
  data?: React.ReactNode;
}

export const ActionWidgetSkeleton = () => {
  return (
    <WidgetCard className="activity-widget">
      <WidgetTitle type="normal">
        <Flex justify="space-between" align="center" wrap="wrap" gap={10}>
          <Skeleton.Input active />
          <Skeleton.Button style={{ width: 140, borderRadius: 15 }} />
        </Flex>
      </WidgetTitle>
      <Skeleton.Button active style={{ width: 10 }} />
    </WidgetCard>
  );
};

const ActionWidget = ({
  title,
  ctaContent,
  onCtaClick,
  data,
}: ActionWidgetProps) => {
  return (
    <WidgetCard className="activity-widget">
      <WidgetTitle type="normal">
        <Flex justify="space-between" align="center" wrap="wrap" gap={10}>
          <span>{title}</span>
          <Button
            size="small"
            className="widget-action-btn"
            onClick={onCtaClick}
          >
            {ctaContent}
          </Button>
        </Flex>
      </WidgetTitle>
      <Title ellipsis={{ tooltip: true }} level={3} className="m-0">
        {typeof data === 'string' || typeof data === 'number'
          ? renderInfoValue(data, 'N/A')
          : data}
      </Title>
    </WidgetCard>
  );
};

export default ActionWidget;
